import {
    Button, Container, Nav, Navbar,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FormBannerProps } from './types';
import SaveAndExitButton from '../SaveAndExitButton';
import SkipLinks from '../../Utilities/skipLinks';
import NavbarMessage from '../../Header/NavbarMessage';
import useUserServices from '../../../hooks/useUserServices';
import { ServiceType } from '../../../api/web-api-client';
import SessionStorageCache from '../../../storage/sessionStorageCache';
import { DashboardTab } from '../../SearchFilter/types';

const FormBanner = ({
    title,
    refTitle,
    subTitle,
    showSaveAndExitButton,
    showGoToDashboardButton,
    discard,
} : FormBannerProps) => {
    const locationOnDiscard = discard?.locationOnDiscard ?? '/';
    const onDiscard = discard?.onDiscard;
    const discardButtonTitle = discard?.discardButtonTitle ?? 'Discard changes';
    const showDiscardButton = discard !== undefined;
    const disableDiscardButton = discard?.disableDiscardButton ?? false;
    const services = useUserServices();
    const [to, setTo] = useState<string>('/dashboard');

    function routeToDashboard(serviceTypeToUse?: ServiceType): string {
        switch (serviceTypeToUse) {
            case ServiceType.TestingCalibration:
                return '/dashboard';
            case ServiceType.PatternApproval:
                return '/dashboard-ta';
            default:
                return '/';
        }
    }

    const navigate = useNavigate();

    const onClick = () => {
        if (onDiscard) {
            onDiscard();
        }

        navigate(locationOnDiscard);
    };

    useEffect(() => {
        const defaultService = services.find((service) => service.isDefault);
        if (defaultService) {
            setTo(routeToDashboard(defaultService.service!));
        }
    }, [services]);

    function goToDashboard() {
        SessionStorageCache().setItem(DashboardTab.Requests, 'set-tabop-after-save');
        navigate(to);
    }

    return (
        <>
            <SkipLinks />
            <header id='header'>
                <NavbarMessage />
                <Navbar bg='nmi-form-navbar' collapseOnSelect expand='lg' aria-labelledby='form-banner'>
                    <Container fluid className='container-lg align-items-stretch p-0'>
                        <Navbar.Brand
                            as='div'
                            id='form-banner'
                            bsPrefix='nmi-form-brand d-flex align-items-center'
                        >
                            <div className='form-banner-title'>
                                <span className='d-block'>
                                    {title}
                                    {refTitle !== null && refTitle !== ''
                                        ? (
                                            <span className='ref-title d-block d-sm-inline ms-sm-2 text-nowrap'>
                                                {refTitle}
                                            </span>
                                        )
                                        : null }
                                </span>
                                {subTitle !== null && subTitle !== ''
                                    ? (
                                        <span className='org-title d-block'>
                                            {subTitle}
                                        </span>
                                    )
                                    : null }
                            </div>
                        </Navbar.Brand>
                        {showSaveAndExitButton === true || showDiscardButton === true
                            ? (
                                <>
                                    <Navbar.Toggle aria-controls='form-navbar' />
                                    <Navbar.Collapse className='p-4'>
                                        <Nav
                                            id='form-navbar'
                                            role='toolbar'
                                            navbar
                                            className='d-grid gap-3 d-lg-block ms-auto me-0 p-3 p-lg-0 text-nowrap'
                                            aria-labelledby='form-navbar-title'
                                        >
                                            <h2 id='form-navbar-title' className='visually-hidden'>Form actions</h2>
                                            {showSaveAndExitButton === true ? <SaveAndExitButton /> : null}
                                            {showDiscardButton === true
                                                ? (
                                                    <Button
                                                        data-testid='discard-changes-button'
                                                        onClick={() => onClick()}
                                                        variant='tertiary-colorbg'
                                                        disabled={disableDiscardButton}
                                                    >
                                                        <i className='icon-close me-1' aria-hidden='true' />
                                                        {discardButtonTitle}
                                                    </Button>
                                                ) : null}
                                        </Nav>
                                    </Navbar.Collapse>
                                </>
                            ) : null}
                        {showGoToDashboardButton === true
                            ? (
                                <>
                                    <Navbar.Toggle aria-controls='form-navbar' />
                                    <Navbar.Collapse className='p-4'>
                                        <Nav
                                            id='form-navbar'
                                            role='toolbar'
                                            navbar
                                            className='d-grid gap-3 d-lg-block ms-auto me-0 p-3 p-lg-0'
                                            aria-labelledby='form-navbar-title'
                                        >
                                            <h2 id='form-navbar-title' className='visually-hidden'>Form actions</h2>
                                            <div className='d-grid d-lg-block'>
                                                <Button
                                                    data-testid='form-go-to-dashboard-portal-button'
                                                    variant='tertiary-colorbg'
                                                    onClick={() => goToDashboard()}
                                                >
                                                    <i className='icon-arrow-right me-1' aria-hidden='true' />
                                                    Go to dashboard
                                                </Button>
                                            </div>
                                        </Nav>
                                    </Navbar.Collapse>
                                </>
                            ) : null}
                    </Container>
                </Navbar>
            </header>
        </>
    );
};

export default FormBanner;
